import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setLoader } from "./MasterSlice";
import * as API from "../../utils/api.service";

export const getTaskListApiCall = createAsyncThunk("taskList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: taskList } = await API.getTaskListApi(submitData);
        dispatch(setLoader(false))
        return taskList;
    } catch (error) {
        throw error;
    }
});

const initialState = {
    taskList: {
        data: [],
        error: null,
    },
};

const taskSlice = createSlice({
    name: "TASK",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTaskListApiCall.fulfilled, (state, action) => {
                state.taskList.data = action.payload;
            })
            .addCase(getTaskListApiCall.rejected, (state, action) => {
                state.taskList.error = action.error.message;
            });
    },
});

export default taskSlice.reducer;